"use strict";

exports.__esModule = true;
exports.default = exports.getInboxBody = void 0;

var _turndown = _interopRequireDefault(require("turndown"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const turndown = new _turndown.default({
  headingStyle: "atx",
  bulletListMarker: "-"
});

const getInboxBody = ({
  message
}) => {
  let html = document.createElement("div");
  html.innerHTML = message;
  const text = html.textContent || html.innerText || message;
  let markdown = message;

  if (message) {
    markdown = turndown.turndown(message);
  }

  return {
    text: text,
    markdown: markdown
  };
};

exports.getInboxBody = getInboxBody;
var _default = getInboxBody;
exports.default = _default;